exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: block;\n  overflow: hidden; }\n\n.panes {\n  height: 100%;\n  width: 200%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.panes div {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/slide-panel/slide-panel.component.scss
// module id = ../../../../../src/app/shared/components/slide-panel/slide-panel.component.scss
// module chunks = main